export default "__VITE_ASSET__abbbc3c9__"